export default __webpack_public_path__ + "static/media/dashboardMenu.62aa76bc.svg";